import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { RowCrudService } from 'src/app/shared/services/row-crud.service';
import { Row } from 'src/app/shared/interfaces/row';

@Component({
  selector: 'app-row-list',
  templateUrl: './row-list.component.html',
  styleUrls: ['./row-list.component.scss']
})
export class RowListComponent implements OnInit {

  rows: Row[];
  row: Row;
  selectedRows: Row[] = [];

  rowDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  constructor(
   // private api: APIService,
    private rowService : RowCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Rows'}
    ];

    this.rows = [];
    this.row = { } as Row ;
  }

  ngOnInit(): void {
    
    this.dataState();
    let s = this.rowService.GetRowsList(); 
    s.snapshotChanges().subscribe(data => {
      this.rows = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.rows.push(jsonItem as Row);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'title', header: 'Title' },
      { field: 'description', header: 'Description' },
      { field: 'actions', header: 'Actions' } 
    ];

    this._selectedColumns = this.cols;

    // Exports
    this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
  }

  dataState() {     
    this.rowService.GetRowsList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.rows);
            doc.save('rows.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.rows);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "rows");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    this.exportService.exportToCsv(this.rows, 'rows', ['title', 'description', '$key', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.row = {} as Row;
    this.submitted = false;
    this.rowDialog = true;
  }

  deleteSelectedRows() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected rows?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            // this.rows = this.rows.filter(val => !this.selectedRows.includes(val));
            // this.selectedRows = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Rows Deleted', life: 3000});
        }
    });
  }

  editRow(row: Row) {
    this.row = {...row};
    this.rowDialog = true;
  }

  deleteRow(row: Row) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + row.title + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.rows = this.rows.filter(val => val.$key !== row.$key);
            this.row = {} as Row;
            this.rowService.DeleteRow(row.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Row Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.rowDialog = false;
    this.submitted = false;
  }

  saveRow() {
    this.submitted = true;

    // if (this.row.companyName.trim()) {
    //     if (this.row.$key) {
    //         this.rows[this.findIndexById(this.row.$key)] = this.row;                
    //         this.messageService.add({severity:'success', summary: 'Successful', detail: 'Row Updated', life: 3000});
    //     }
    //     else {
    //         // this.row.id = this.createId();
    //         // this.row.image = 'product-placeholder.svg';
    //         this.rows.push(this.row);
    //         this.messageService.add({severity:'success', summary: 'Successful', detail: 'Row Created', life: 3000});
    //     }
    //}

    this.rowService.AddRow(this.row);
    this.messageService.add({severity:'success', summary: 'Successful', detail: 'Row Created', life: 3000});

        this.rows = [...this.rows];
        this.rowDialog = false;
        this.row = { } as Row;
    
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.rows.length; i++) {
        if (this.rows[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeRow(row : Row) {
    console.log("SAVE", row);
  }

}
